module.exports = __webpack_public_path__ + "img/serifnew_box16.9480b4e2.jpg";